/* eslint-disable */

/**
 * Get cookie value by name. retailCRM integration with Universal Analytics uses it.
 * Name should match pattern [a-zA-Z0-9_]+
 *
 * @param string name
 *
 * @return mixed
 **/

function getRetailCrmCookie(name) {
    var matches = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : "";
}
export default ({ app, $axios }, inject) => {
    (function (i, s, o, g, r, a, m) {
        i["GoogleAnalyticsObject"] = r;
        (i[r] =
            i[r] ||
            function () {
                (i[r].q = i[r].q || []).push(arguments);
            }),
            (i[r].l = 1 * new Date());
        (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
    })(window, document, "script", "https://www.google-analytics.com/analytics.js", "ga");
    // window.ga = () => {
    //     console.log(`ga dummy`);
    // };

    /*
     ** Устанавливаем текущую страницу
     */
    // ga("create", "UA-174153122-1", "auto");
    /*
     ** Вызывается каждый раз после смены роута (при инициализации тоже)
     */
    app.router.afterEach((to, from) => {
        // ga("set", "page", to.fullPath);
        // ga("set", "dimension1", getRetailCrmCookie("_ga"));
        // ga("send", "pageview");

        var rrPartnerId = "5f4416b197a5283f80ad81c0";
        window.rrPartnerId = rrPartnerId;
        var rrApi = {};
        var rrApiOnReady = rrApiOnReady || [];
        rrApi.addToBasket =
            rrApi.order =
            rrApi.categoryView =
            rrApi.view =
            rrApi.recomMouseDown =
            rrApi.recomAddToCart =
                function () {};
    });

    // diginetica
    const digiScript = document.createElement("script");
    digiScript.src = "//cdn.diginetica.net/3888/client.js"; // Замените SITEID на фактический идентификатор
    digiScript.defer = true;
    digiScript.async = true;
    document.head.appendChild(digiScript);
};
sessionStorage.setItem("is_loaded", 1);
